import { IconArrowRight } from "@tabler/icons-react";
import Link from "next/link";
import { Button, buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const DietHubSectionHeader = ({
  label,
  title,
  callback,
  description,
}: {
  label: string | null;
  title?: string | null;
  callback: {
    label: string;
    href: string;
  } | null;
  description?: string | null;
}) => {
  if (!(label || title || callback || description)) {
    return null;
  }

  return (
    <div className="space-y-2">
      {label ? (
        <p className="font-medium text-brand-violet uppercase tracking-wide">
          {label}
        </p>
      ) : null}
      {title || callback ? (
        <div className="flex flex-col gap-4 md:flex-row md:items-center">
          {title ? (
            <h2 className="font-medium text-2xl lg:text-5xl">{title}</h2>
          ) : null}
          {callback && (
            <Button
              className={cn(
                buttonVariants({ variant: "link" }),
                "max-md:min-h-0 max-md:justify-start max-md:px-0 max-md:py-0 md:ml-auto md:pr-0",
              )}
              asChild
              variant="link"
            >
              <Link
                href={callback.href}
                rel="noopener noreferrer"
                target="_blank"
              >
                {callback.label}
                <IconArrowRight className="ml-2 size-5" stroke={2} />
              </Link>
            </Button>
          )}
        </div>
      ) : null}
      {description ? (
        <p className="max-w-3xl text-base text-brand-grey5">{description}</p>
      ) : null}
    </div>
  );
};
